function Studiothink() {

  this.consts = {
    namespace: 'studiothink',
    breakpoints: {
      no: 0, 
      xs: 480,
      sm: 600,
      md: 782,
      lg: 960,
      xl: 1080,
      xxl: 1280,
      xxxl: 1440
    },
    breakpoint: 'md',
    breakpointNav: 'lg',
    transition: {
      fast: 275,
      medium: 400,
      slow: 650
    }
  };

  this.observeElements = '#site-header > *, h1, h2, h3, h4, p, cite, .wp-block-image, .frm_forms, #site-footer > .wp-block-group, .wp-block-button, .filter-wrapper, .loop-inner-grid, .wp-block-st-testimonials, .wp-block-media-text__media, .frm_forms, .wp-block-st-carousel, .wp-block-st-social, .languages-drawer-overlay__list, .map-wrapper';
  
  this.viewPort = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    scrollbarYWidth: window.innerWidth - document.documentElement.clientWidth,
    scrollbarXHeight: window.innerHeight - document.documentElement.clientHeight
  };
  this.uniqueIdLast = 0;
  
  this.header = {
    obj: document.querySelector( 'header.page-header' ),
    height: {
      no: 97,
      md: 132
    }
  }

  this.windowPageYOffsetLast = 0;

  var st = this;
  this.isSmallScreen = function( breakpoint ) {
    breakpoint = breakpoint || st.consts.breakpoint;
    return ( st.consts.breakpoints[ breakpoint ] > st.viewPort.width );
  };
  this.isSmallScreenNav = function() {
    return ( st.consts.breakpoints[ st.consts.breakpointNav ] > st.viewPort.width + st.viewPort.scrollbarYWidth );
  };
  
  this.resize = function() {

    st.viewPort = {
      width: document.documentElement.clientWidth,
      height: window.visualViewport.height,
      scrollbarYWidth: window.innerWidth - document.documentElement.clientWidth,
      scrollbarXHeight: window.innerHeight - document.documentElement.clientHeight
    }
    
    document.documentElement.style.setProperty('--vh',st.viewPort.height*.01+'px');
    document.documentElement.style.setProperty('--vw',st.viewPort.width*.01+'px');
    document.documentElement.style.setProperty('--sw',st.viewPort.scrollbarYWidth+'px');

    if ( !st.isSmallScreenNav() ) {

      if ( document.documentElement.classList.contains( 'toggle-main-nav' ) ) document.documentElement.classList.remove( 'toggle-main-nav' );

    }
    
  };

  this.uniqueId = function( prefix ) {
    
    var id = '' + ++st.uniqueIdLast;
    return prefix ? prefix + id : 'st-' + id;
  };
    
  function init() {
    
    if ( window.st ) return false;

    document.documentElement.classList.add('st-initialized');
    if ( 'ontouchstart' in document.documentElement ) document.documentElement.classList.add('st-touch');
    if ( st.header.height.md <= window.pageYOffset ) document.documentElement.classList.add('st-scrolling');
    
    st.resize();
    
    return true;
  }
  init();
  
  window.st = window.st || this;
  
}
new Studiothink();

( function( $ ) {

  $(document).ready( function() {

    st.resize();
    st.windowPageYOffsetLast = window.pageYOffset;

    $(window).on( 'load', function() {

    } ).on( 'resize orientationchange', function() {

      st.resize();
      
    } ).on( 'scroll', function( e ) {

      if ( 0 === window.pageYOffset ) document.documentElement.classList.remove( 'is-scrolling' );
      else document.documentElement.classList.add( 'is-scrolling' );

      if ( 0 === window.pageYOffset || st.windowPageYOffsetLast < window.pageYOffset ) document.documentElement.classList.remove( 'is-scrolling-up' );
      else document.documentElement.classList.add( 'is-scrolling-up' );

      st.windowPageYOffsetLast = window.pageYOffset;

    } ).on( 'hashchange', function( e ) {
      
      if ( window.location.hash.match( /^#?!\// ) ) {
        
        e.preventDefault();
        st.hashParts = window.location.hash.replace( /\/$/, '').split('/');

        console.log(st.hashParts);
        
        if ( 'string' === typeof st.hashParts[1] ) {
          
          if ( 'top' === st.hashParts[1] ) {
            
            $( 'html, body' ).stop( true ).animate( { scrollTop: 0 }, st.consts.transition.slow );
            history.replaceState( undefined, document.title, window.location.pathname );
            
          } else if ( 'start' === st.hashParts[1] ) {
            
            var $target = $( '#site-main > div:nth-child(2)' );
            $( 'html, body' ).stop( true ).animate( { scrollTop: $target.offset().top - st.header.height.md }, st.consts.transition.slow );
            history.replaceState( undefined, document.title, window.location.pathname );
            $target.focus();
            
          } else if ( 'undefined' === typeof st.hashParts[2] && $( '#' + st.hashParts[1] ).length ) {
            
            var $target = $( '#' + st.hashParts[1] );
            $('html, body').stop( true ).animate( { scrollTop: $target.offset().top - st.header.height.md }, st.consts.transition.slow, function() {
              
            } );
          
          } else if ( st.hashParts[1].length && 'string' === typeof st.hashParts[2] ) {
            
            if ( 0 < st.hashParts[2].length ) {
              
              switch( st.hashParts[1] ) {
                case '':
                  break;
              }

            }

          }

          if ( document.documentElement.classList.contains( 'toggle-mobile-nav' ) ) document.documentElement.classList.remove( 'toggle-mobile-nav' );
          
        }
        return false;
      }
      if ( document.documentElement.classList.contains( 'toggle-mobile-nav' ) ) document.documentElement.classList.remove( 'toggle-mobile-nav' );
      
    } ).trigger( 'scroll' );
    if ( window.location.hash.length ) $( window ).trigger( 'hashchange' );

    $( '[data-toggle-id]' ).on( 'click', function( e ) {
      
      e.preventDefault();

      var id = this.dataset.toggleId;
      
      if ( document.documentElement.classList.contains( 'toggle-' + id ) ) {
        document.documentElement.classList.remove( 'toggle-' + id );
        document.getElementById( id ).setAttribute('aria-expanded', false);
      } else {
        document.documentElement.classList.add( 'toggle-' + id );
        document.getElementById( id ).setAttribute('aria-expanded', true);
      }
      
    } );


    $( '.next-page-link-wrapper > a' ).on( 'click', function( event ) {
      event.preventDefault();

      var $this = $(this), _this = this, pageCurrent = 1;

      if ( _this.classList.contains( 'rest-initialized' ) ) return false;
      _this.classList.add( 'rest-initialized' );

      if ( this.dataset.pageCurrent ) pageCurrent = parseInt( _this.dataset.pageCurrent );

      var restUrl = '/wp-json/wp/v2/posts?';
      if ( _this.dataset.perPage ) restUrl = restUrl + 'per_page=' + _this.dataset.perPage + '&';
      if ( _this.dataset.exclude ) restUrl = restUrl + 'exclude=' + _this.dataset.exclude + '&';
      if ( _this.dataset.term ) restUrl = restUrl + 'categories=' + _this.dataset.term + '&';

      $.ajax({
        url: restUrl + 'page=' + ( pageCurrent + 1 ),
        method: 'GET',
        beforeSend: function(xhr){

          $this.addClass( 'rest-running' );
          //xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );

        }
      }).done( function( data, textStatus, jqXHR ) {

        pageCurrent++

        if ( data.length ) {

          for ( var i = 0; i < data.length; i++ ) {

            let template = document.createElement( 'template' );
            template.innerHTML = data[i].card;

            let card = template.content.firstChild;
            //card.classList.add( 'observing' );

            _this.parentElement.previousElementSibling.appendChild(card);

            window.setTimeout( function() { card.classList.add( 'active' ); }, 75 + ( i * 125 ) );

          }

        }

        if ( parseInt( jqXHR.getResponseHeader( 'x-wp-totalpages' ) ) > pageCurrent ) {
          _this.dataset.pageCurrent = pageCurrent;
        } else {
          _this.parentNode.parentNode.removeChild( _this.parentNode );
        }

        // _this.dataset.pageCurrent = pageCurrent + 1;
        
      }).fail( function( jqXHR, textStatus, errorThrown ) {

        _this.parentNode.parentNode.removeChild( _this.parentNode );

      } ).always( function( data_or_jqXHR, textStatus, jqXHR_or_errorThrown ) {

        _this.classList.remove( 'rest-initialized' );
        _this.classList.remove( 'rest-running' );

      } );

    } ).text( 'Load More' );

    //lity on video link//
    $('a[href]:not([data-lity])').each( function() {
      var is_video = false;
      if ( 'string' === typeof this.href ) {
        if ( -1 !== this.href.indexOf( 'youtu.be' ) ) is_video = true;
        // if ( -1 !== this.href.indexOf( '.youtube.' ) ) is_video = true;
        if ( -1 !== this.href.indexOf( '.mp4' ) ) is_video = true;
        if ( -1 !== this.className.indexOf( 'button-video' ) ) is_video = true;
        if ( -1 !== this.parentNode.className.indexOf( 'button-video' ) ) is_video = true;
      }
      if ( true === is_video && 'function' === typeof lity ) {
        if ( -1 === this.className.indexOf( 'button-video' ) ) this.className += ' button-video';
        this.setAttribute( 'data-lity-extra' , 'true' );
      }
    } );
    $( document ).on( 'click', '[data-lity-extra]', lity);

    $('.wp-block-video > video').each( function() {

      var video = this, block = this.parentNode;
      video.controls = false;

      block.classList.add( 'play-me' );
      block.addEventListener( 'click', function( e ) {

        if ( !this.classList.contains( 'play-me' ) ) return;

        e.preventDefault();
        e.stopPropagation();

        this.classList.remove( 'play-me' );
        video.controls = true;
        video.play();

      } );

    } );

    if ( 'IntersectionObserver' in window ) {
  
      var parallaxOffsetTravel = function( element ) {

        this.element = element;
        let target = this;

        return function( event ) {

          var rect = target.element.getBoundingClientRect(), height = target.element.clientHeight;
          var offsetTop = rect.top + window.pageYOffset;
            
          var start = offsetTop - document.documentElement.clientHeight, end = offsetTop + height, distance = parseInt( target.element.dataset.parallaxDistance ), direction = target.element.dataset.parallaxDirection;
  
          if ( isNaN( distance ) ) distance = 100;
          if ( 'Y' !== direction ) direction = 'X';

          var travelDistance = rect.height * 2 + document.documentElement.clientHeight;
          var travelPosition = window.pageYOffset + document.documentElement.clientHeight - offsetTop;

          if ( 0 > travelPosition ) travelPosition = 0;
          if ( travelDistance < travelPosition ) travelPosition = travelDistance;

          var transformOffset = distance * ( travelPosition / travelDistance ) - ( distance / 2 );

          target.element.style.transform = 'translate' + direction + '(' + transformOffset + 'px)';

        } 
  
      }

      var observeSection = new IntersectionObserver( function( entries ) {
        
        entries.forEach( function( entry ) {
        
          var content = entry.target;
          
          if ( entry.isIntersecting ) {
            
            content.classList.add( 'intersected' );
            content.classList.add( 'intersecting' );

            if ( content.dataset.parallax && content.parallaxOffsetTravel ) window.addEventListener( 'scroll', content.parallaxOffsetTravel );

            if ( content.classList.contains( 'last-line' ) ) {
              content.parentNode.classList.add( 'intersected' );
            }

            if ( content.classList.contains( 'first-line' ) && content.parentNode.classList.contains( 'intersected' ) ) {
              content.parentNode.classList.remove( 'intersected' );
            }

          } else {

            content.classList.remove( 'intersecting' );

            if ( content.dataset.parallax && content.parallaxOffsetTravel ) window.removeEventListener( 'scroll', content.parallaxOffsetTravel );

          }
          
        });
        
      } );
      
      // Standard fade-in and slide-up.
      var contentNodes = document.querySelectorAll( st.observeElements );
      for( var i = 0; i < contentNodes.length; i++ ) {

        if (!contentNodes[i].closest('.observing')) {

          contentNodes[i].classList.add( 'observing' );
          if ( 0 !== window.pageYOffset ) contentNodes[i].classList.add( 'intersected' );
          else observeSection.observe( contentNodes[i] );

          if ( contentNodes[i].classList.contains( 'last-line' ) ) {
            contentNodes[i].parentNode.classList.add( 'observing' );
            if ( 0 !== window.pageYOffset ) contentNodes[i].parentNode.classList.add( 'intersected' );
          }
        }
        
      }

      // Parallax effects.
      var contentNodes = document.querySelectorAll( '.parallax-el' );
      for( var i = 0; i < contentNodes.length; i++ ) {

        contentNodes[i].dataset.parallax = true;

        if ( contentNodes[i].classList.contains( 'image-1' ) ) {
          contentNodes[i].dataset.parallaxDistance = -150;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        } else if ( contentNodes[i].classList.contains( 'image-2' ) ) {
          contentNodes[i].dataset.parallaxDistance = 200;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        } else if ( contentNodes[i].parentNode.classList.contains( 'line-1' ) ) {
          contentNodes[i].dataset.parallaxDistance = 25;
          contentNodes[i].dataset.parallaxDirection = 'X';
        } else if ( contentNodes[i].parentNode.classList.contains( 'line-2' ) ) {
          contentNodes[i].dataset.parallaxDistance = -25;
          contentNodes[i].dataset.parallaxDirection = 'X';
        } else if ( contentNodes[i].parentNode.classList.contains( 'line-3' ) ) {
          contentNodes[i].dataset.parallaxDistance = -50;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        } else if ( contentNodes[i].classList.contains( 'compass-graphic' ) ) {
          contentNodes[i].dataset.parallaxDistance = 100;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        } else {
          contentNodes[i].dataset.parallaxDistance = 200;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        }

        contentNodes[i].parallaxOffsetTravel = new parallaxOffsetTravel( contentNodes[i] );
        observeSection.observe( contentNodes[i] );
        
      }
      
    }

    // Add classes and ID to page  sections
    let sectionCount = 1;
    $('#site-main').children('.wp-block-cover, .wp-block-columns, .wp-block-group').each(function() {
      $(this).addClass('section-'+sectionCount);
      if (!$(this).attr('id')) {
        $(this).attr('id', 'section-'+sectionCount);
      }
      sectionCount++;
    });
    // Rewrite scroll down arrow href on hero to next section id
    $('.studiothink-scroll-down').each(function() {
      let nextSiblingAnchor = '#' + $(this).next().attr('id');
      $(this).attr('href', nextSiblingAnchor);
    });

  //  Select 2
    $('.select2').find('select').select2({
      minimumResultsForSearch: Infinity,
      dropdownAutoWidth: true,
      theme: "flat"
    });

    // handle form field labels
    $('.frm_form_field input, .frm_form_field select, .frm_form_field textarea').on('change', function() {
      if ($(this).val().length > 0) {
        $(this).parent().addClass("has-val");
      } else {
        $(this).parent().removeClass("has-val");
      }
    });
      
  } );

} )( jQuery );
